export function isNumber(possibleNumber: unknown): boolean {
    return Boolean(possibleNumber === 0 || (possibleNumber && !isNaN(Number(possibleNumber))));
}
